import axios from "axios";

import dotenv from 'dotenv';

dotenv.config();

//const s = process.env.REACT_APP_API_HOST + ":" + process.env.REACT_APP_PORT_API + "/api/" ;
const s = process.env.REACT_APP_API_HOST; //https://tg-api-locator.tg41.uk/api/
const API_URL = s.replace(/'/g, "");

const API_IMAGE_WEB = process.env.REACT_APP_API_IMAGE_WEB

//const aa ="ttt" process.env.REACT_APP_API_HOST + "

//Get al images by locatorId
export function api_req_thumbnails(locatorId) {

  //console.log(`${API_IMAGE_WEB}/get_all_images_by_id/${locatorId}`)
  return axios.get(`${API_IMAGE_WEB}/get_all_images_by_id/${locatorId}`)

}

export function api_req_delete_all_images_by_id(locatorId) {

  console.log(`${API_IMAGE_WEB}/delete_images/${locatorId}`)
  axios.delete(`${API_IMAGE_WEB}/delete_images/${locatorId}`)
  .then(
    (response) => {
      console.log(response.data)
    },
    (error) => {
      console.log(error.message)
    }

  )
}

export function api_req_locid_info(locationId, chat_id, token) {


    //console.log("axios test")
    //console.log(API_URL)
    const options = {
        method: 'POST',
        url: API_URL + "tg_location_id_req_data",
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token
        },
        data: {"location_id": locationId, "chat_id": chat_id.toString()}
      };
    //console.log(options) 
    return axios.request(options) 

}

export function api_req_locid_delete(locationId, token) {

  console.log(locationId)
  console.log(token)
  //console.log(API_URL)
  const options = {
      method: 'DELETE',
      url: API_URL + "tg_location_id_req_data_delete",
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      data: {location_id: locationId}
    };
 // console.log(options) 
  return axios.request(options) 

}

export function api_req_locid_edit(token, data) {

    console.log(token)
    console.log(data)
    //console.log(API_URL)
    const options = {
        method: 'POST',
        url: API_URL + "tg_location_id_req_data_edit",
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token
        },
        data: data
      };
   // console.log(options) 
    return axios.request(options) 

}

export function api_req_get_tags(chat_id, interval_days, token ) {

  console.log(token)
  //console.log(API_URL)
  const options = {
      method: 'GET',
      url: API_URL + "tg_chat_id_tags_list",
      params: {chat_id: chat_id, interval_days: interval_days},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      //data: {chat_id: chat_id}
    };
 // console.log(options) 
  return axios.request(options) 

}

export function api_req_get_qty_location_rows(chat_id, token, tags, str_search) {

  //console.log(token)
  //console.log(API_URL)
  const options = {
      method: 'GET',
      url: API_URL + "tg_tag_and_str_search_count",
      params: {chat_id: chat_id, tags: tags, str_search: str_search},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      //data: {chat_id: chat_id}
    };
 // console.log(options) 
  return axios.request(options) 

}

export function api_req_get_location_rows(chat_id, token, tags, str_search) {

  //console.log(token)
  //console.log(API_URL)
  const options = {
      method: 'GET',
      url: API_URL + "tg_tag_and_str_search",
      params: {chat_id: chat_id, tags: tags, str_search: str_search},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      //data: {chat_id: chat_id}
    };
 // console.log(options) 
  return axios.request(options) 

}

/* 
{
    "location_id": "20",
    "chat_id": "404529009",
		"gr_tags": "Hello",
		"url": "http://test1",
		"text": "Hello1 http://test1",
		"description": "description http://test1"
	
}
*/


/* POST
import axios from "axios";

const options = {
  method: 'POST',
  url: 'http://xtal.asia:4016/api/tg_post_test',
  headers: {
    'Content-Type': 'application/json',
    'User-Agent': 'insomnia/9.3.3',
    'x-access-token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNzI2MDU2MjQwLCJleHAiOjE3MjYxNDI2NDB9.rR0xQ6ZGGfuq76cGquNHTgMfOM4Qut1G_B_XmSpKXDM'
  },
  data: {test1: 'mod', tes2: '123456'}
};

axios.request(options).then(function (response) {
  console.log(response.data);
}).catch(function (error) {
  console.error(error);
});

*/